import { render, staticRenderFns } from "./Plentymarkets.vue?vue&type=template&id=73350532&scoped=true&"
import script from "./Plentymarkets.vue?vue&type=script&lang=js&"
export * from "./Plentymarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73350532",
  null
  
)

export default component.exports